"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var UploadNotification_1 = require("./UploadNotification");
/**
 * Info about data upload.
 *
 * @author Jaroslav Sevcik
 */


var DataUpload =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(DataUpload, _DomainObject_1$Domai);

  /**
   *
   * @param id the internal id
   * @param date the date of the upload
   * @param type various kinds of data can be uploaded
   * @param researchType the type of the research the data belong to
   * @param researchName the name of thr research the data belong to
   * @param agencyType the type of agencies
   * @param state the upload status based on user decision
   * @param validity the validity of the uploaded data
   * @param userId the internal id of the user who made this upload
   * @param userName the name of the user who made this upload
   * @param importedRowsCount the number of successfully imported rows
   * @param notifications the list of upload notifications
   */
  function DataUpload(id, date, type, researchType, researchName, agencyType, state, validity, userId, userName, importedRowsCount, notifications) {
    var _this;

    _classCallCheck(this, DataUpload);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataUpload).call(this));
    _this.id = id;
    _this.date = date;
    _this.type = type;
    _this.researchType = researchType;
    _this.researchName = researchName;
    _this.agencyType = agencyType;
    _this.state = state;
    _this.validity = validity;
    _this.userId = userId;
    _this.userName = userName;
    _this.importedRowsCount = importedRowsCount;
    _this.notifications = notifications;
    return _this;
  }

  return DataUpload;
}(DomainObject_1.DomainObject);

exports.DataUpload = DataUpload;

DataUpload.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(DataUpload.name);
  return {
    id: builder.str('id'),
    date: builder.date('date'),
    type: builder.str('type'),
    researchType: builder.opt(builder.str('researchType')),
    researchName: builder.opt(builder.str('researchName')),
    agencyType: builder.opt(builder.str('agencyType')),
    state: builder.str('state'),
    validity: builder.str('validity'),
    userId: builder.str('userId'),
    userName: builder.opt(builder.str('userName')),
    importedRowsCount: builder.opt(builder.num('importedRowsCount')),
    notifications: builder.listOf(UploadNotification_1.createUploadNotificationSchema(builder, 'notifications'))
  };
}();